import { makeStyles } from "@material-ui/core";

export const useChangeEmailModalStyles = makeStyles((theme) => ({
    dialog: {
        "& .MuiDialogContent-root": {
            paddingTop: 16,
            paddingBottom: 16
        },
        "& .MuiTypography-h3": {
            padding: "12px 0px"
        },
        "& .MuiTypography-subtitle1": {
            marginBottom: 20
        }
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        width: 598,
        height: 650,
        position: "relative",
        overflowX: "hidden",
        padding: "0px 32px"
    },
    logoIcon: {
        margin: "16px auto 6px",
        textAlign: "center",
        "& svg": {
            height: "2.30em",
            color: theme.palette.primary.main
        }
    },
    infoWrapper: {
        marginTop: 38,
        display: "flex",
        justifyContent: "space-between"
    },
    selectWrapper: {
        marginBottom: 20,
        "& .MuiFormControl-root": {
            width: "100%"
        }
    },
    formWrapper: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1
    },
    footer: {
        width: "100%",
        marginTop: "auto",
        marginBottom: "32px",
        "& .MuiButton-root": {
            height: "42px",
        }
    }
}));